
























import Vue, { PropType } from 'vue'
import { Discount, SalesProduct } from '@/types/generated/graphql'
import Product, { Input as ProductInput } from './Product.vue'
import Panel from './Panel.vue'

export type Input = {
  orderItems: ProductInput[]
}

type Props = {
  products: SalesProduct[]
  value: Input
  discount: Discount | null
}

type Computed = {
  orderItems: Input['orderItems']
}

type Methods = {
  validate: (value: ProductInput[]) => void
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: 'ProductList',
  components: { Product, Panel },
  props: {
    products: {
      type: Array,
    },
    value: {
      type: Object,
      default: () => ({ orderItems: [] }),
    },
    discount: {
      type: Object as PropType<Discount>,
    },
  },
  computed: {
    orderItems: {
      get() {
        return this.value.orderItems
      },
      set(value) {
        const input: Input = { orderItems: value }
        this.$emit('input', input)
      },
    },
  },
})
